export default "__VITE_ASSET__BthY9$8d__"